import config from 'Shared/config';
export const FRONT_ENV = window.location.host.startsWith('localhost') ? 'local' : config.prod_url.startsWith(document.location.origin) ? 'prod' : 'dev';
export const MAPS_API_KEY = FRONT_ENV !== 'prod' ? config.MAPS_API_KEY : config.PROD_MAPS_API_KEY;
export const CAPTCHA_V3_KEY = FRONT_ENV !== 'prod' ? config.captcha_v3_key : config.prod_captcha_v3_key;
export const SAFERPAY_API = FRONT_ENV !== 'prod' ? config.SAFERPAY_API : config.PROD_SAFERPAY_API;
export default {
  MAPS_API_KEY,
  FRONT_ENV,
  CAPTCHA_V3_KEY,
  SAFERPAY_API
};
